import { Stack, Typography } from "@mui/material";

import { AccordionCustom } from "../AccordionCustom";
import { DoubtListProps } from "./types";

export const DoubtList: React.FC<DoubtListProps> = ({ title, description, doubtList }) => {
  return (
    <Stack direction="column">
      <Stack>
        <Typography component="div" fontWeight={600} alignSelf={{ xs: "start", sm: "center", md: "center" }} fontSize={{ md: 32, xs: 24 }}>
          {title ?? "Ficou com alguma dúvida?"}
        </Typography>

        <Typography
          component="div"
          fontSize={16}
          textAlign={{ xs: "start", sm: "center", md: "center" }}
          alignSelf={{ xs: "start", sm: "center", md: "center" }}
          color="#58595B"
          marginTop={{
            md: "20px",
            xs: "8px"
          }}
        >
          {description ?? "Com dúvidas sobre o KMV? Consulte nossas perguntas frequentes e saiba mais sobre nosso programa de fidelidade."}
        </Typography>
      </Stack>

      <Stack
        spacing={1}
        marginTop={{
          md: "62px",
          xs: "48px"
        }}
      >
        {doubtList?.map((item, index) => (
          <AccordionCustom key={index} question={item.question} answer={item.answer} />
        ))}
      </Stack>
    </Stack>
  );
};
